import { Box } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import { ReactNode } from 'react';

import { LeftMenu } from '@/components/shared/components/LeftMenu/LeftMenu';
import { MobileMenu } from '@/components/shared/components/MobileMenu';
import { SuperSearchBarDialog } from '@/components/shared/components/SuperSearchBar/SuperSearchBarDialog';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';
import { useUIWrapper } from '@/hooks/useUIWrapper';

export function Wrapper(props: { children: NonNullable<ReactNode> }) {
  const { appStarted } = useUserContext();
  const {
    state: { showLeftMenu },
  } = usePageContext();

  const { MAX_PAGE_WIDTH, leftMenuWidth, containerPadding, containerMaxWidth } = useUIWrapper();
  const { md } = useScreen();
  const { typography, background } = useCustomTheme();

  const fontFamily = typography.fontFamily;

  const { children } = props;

  const pageLeftSpace = md ? (showLeftMenu ? leftMenuWidth : '10px') : 0;

  return (
    <>
      {md && <LeftMenu />}
      {!md && appStarted && <MobileMenu />}
      <SuperSearchBarDialog />
      <Box
        boxSizing={'border-box'}
        style={{
          backgroundColor: background,
          fontFamily: fontFamily,
          position: 'relative',
          width: '100%',
          maxWidth: MAX_PAGE_WIDTH,
          paddingLeft: pageLeftSpace,
          transition: 'padding-left 0.5s ease',
        }}
      >
        <Container
          style={{
            padding: `60px ${containerPadding} 0  `,
            height: '100%',
            width: '100%',
            maxWidth: containerMaxWidth,
          }}
        >
          {children}
        </Container>
      </Box>
    </>
  );
}
